import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Toaster } from 'react-hot-toast';

import '@fontsource-variable/inter';
import '@fontsource-variable/outfit';
import '@fontsource-variable/noto-sans-lao';

import { theme } from '@/theme';
import { router } from '@/router';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme} defaultMode="dark">
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'rgba(18,24,38,0.95)',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.12)',
            },
          }}
        />
        <RouterProvider router={router} />
      </LocalizationProvider>
    </ThemeProvider>
  </StrictMode>,
);
